const ERROR_MSGS = {
  somethingWentWrong: 'Something went wrong. Please try again later'
};

export default ERROR_MSGS;
